
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ExtraUsersMetaData} from "@/models/module-extra-users-meta-data";
import { PlanModule } from "@/models/plan-module";

export default FormLike.extend({
	data(){
		return {
			count: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>PlanModule,
			required: true
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.count = ExtraUsersMetaData.create(this.value.MetaData).getExtraUsers();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			if (!this.isValid) return;
			ExtraUsersMetaData.create(this.value.MetaData).setExtraUsers(this.count);
			this.$emit("close");
		}
	}
});
